var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "dscrud",
            attrs: {
              page: _vm.dsPage,
              data: _vm.tableDsData,
              option: _vm.tableDsOption,
              "before-open": _vm.handleOpenBefore,
            },
            on: {
              "update:page": function ($event) {
                _vm.dsPage = $event
              },
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshDsChange,
              "on-load": _vm.getDsList,
            },
            model: {
              value: _vm.dsForm,
              callback: function ($$v) {
                _vm.dsForm = $$v
              },
              expression: "dsForm",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }